/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as r } from "../core/maybe.js";
import { makeAbsolute as e, makeRelative as t, isAbsolute as o, normalize as s, isDataProtocol as l, changeDomain as a, hasSameOrigin as u, appUrl as n } from "../core/urlUtils.js";

function c(r, o) {
  var s = o && o.url && o.url.path;

  if (r && s && (r = e(r, s, {
    preserveProtocolRelative: !0
  }), o.portalItem && o.readResourcePaths)) {
    var _e = t(r, o.portalItem.itemUrl);

    h.test(_e) && o.readResourcePaths.push(o.portalItem.resourceFromPath(_e).path);
  }

  return I(r, o && o.portal);
}

function i(r, a) {
  var u = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (!r) return r;
  !o(r) && a && a.blockedRelativeUrls && a.blockedRelativeUrls.push(r);
  var n = e(r);

  if (a) {
    var _e2 = a.verifyItemRelativeUrls && a.verifyItemRelativeUrls.rootPath || a.url && a.url.path;

    if (_e2) {
      var _o = I(_e2, a.portal);

      n = t(I(n, a.portal), _o, _o), n !== r && a.verifyItemRelativeUrls && a.verifyItemRelativeUrls.writtenUrls.push(n);
    }
  }

  return n = v(n, a && a.portal), o(n) && (n = s(n)), null != a && a.resources && null != a && a.portalItem && !o(n) && !l(n) && 0 === u && a.resources.toKeep.push({
    resource: a.portalItem.resourceFromPath(n)
  }), n;
}

function m(r, e, t) {
  return c(r, t);
}

function p(r, e, t, o) {
  var s = i(r, o);
  void 0 !== s && (e[t] = s);
}

var f = /\/items\/([^\/]+)\/resources\//,
    h = /^\.\/resources\//;

function U(e) {
  var t = r(e) ? e.match(f) : null;
  return r(t) ? t[1] : null;
}

function v(r, e) {
  return e && !e.isPortal && e.urlKey && e.customBaseUrl ? a(r, "".concat(e.urlKey, ".").concat(e.customBaseUrl), e.portalHostname) : r;
}

function I(r, e) {
  if (!e || e.isPortal || !e.urlKey || !e.customBaseUrl) return r;
  var t = "".concat(e.urlKey, ".").concat(e.customBaseUrl);
  return u(n, "".concat(n.scheme, "://").concat(t)) ? a(r, e.portalHostname, t) : a(r, t, e.portalHostname);
}

var R = Object.freeze({
  __proto__: null,
  fromJSON: c,
  toJSON: i,
  read: m,
  write: p,
  itemIdFromResourceUrl: U
});
export { c as f, U as i, R as p, m as r, i as t, p as w };